<template>
  <section
    class="bg-gradient-to-r from-gray-100/70 to-gray-100 relative py-8 sm:py-12"
  >
    <div class="container relative">
      <h1 class="text-3xl/tight font-medium">Aboneliklerim</h1>
    </div>
    <div
      v-if="isLoading"
      class="flex justify-center items-center h-screen"
    ></div>
    <div v-else>
      <SubscriptionListView
        :subscriptions="subscriptions"
        v-if="subscriptions != null && subscriptions.length > 0 && !isLoading"
      />
      <SubscriptionWizardView v-else />
    </div>
  </section>
</template>

<script setup>
import { getUserSubscriptions } from "@/services/userServices";
import { ref, onMounted } from "vue";
import SubscriptionWizardView from "@/views/SubscriptionsWizardView.vue";
import SubscriptionListView from "@/views/SubscriptionsListView.vue";
const subscriptions = ref([]);
const isLoading = ref(true);

onMounted(async () => {
  subscriptions.value = await getUserSubscriptions();
  isLoading.value = false;
});
</script>
